module.exports = __webpack_public_path__ + "img/technology.17378430.svg";